import { createStore } from '@mgc/map-client-shared/lib/ReduxStore';
import reducers from './reducers';

export default createStore(reducers);



// WEBPACK FOOTER //
// ./app/store.js